import firebase from "firebase/app";
import "firebase/functions";

export async function getZendeskMessagingToken(): Promise<string> {
  const fn = firebase
    .functions()
    .httpsCallable("zendesk-authenticateMessaging");
  const result = await fn();
  return (result.data as { jwt: string }).jwt;
}

export async function getZendeskHelpCenterToken(): Promise<string> {
  const fn = firebase
    .functions()
    .httpsCallable("zendesk-authenticateHelpCenter");
  const result = await fn();
  return (result.data as { jwt: string }).jwt;
}
